import { produce } from "immer";
import {
  SEARCH_CARE_PLAN_TEAM,
  SEARCH_CARE_PLAN_TEAM_SUCCESS,
  SEARCH_CARE_PLAN_TEAM_FAILURE,
  FETCH_CARE_PLAN_TEAM,
  FETCH_CARE_PLAN_TEAM_SUCCESS,
  FETCH_CARE_PLAN_TEAM_FAILURE,
  ADD_CARE_PLAN_TEAM,
  ADD_CARE_PLAN_TEAM_SUCCESS,
  ADD_CARE_PLAN_TEAM_FAILURE,
  FETCH_CARE_PLAN_TEAM_MEMBER,
  FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS,
  FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE,
  EDIT_CARE_PLAN_TEAM,
  EDIT_CARE_PLAN_TEAM_SUCCESS,
  EDIT_CARE_PLAN_TEAM_FAILURE,
  DELETE_CARE_PLAN_TEAM,
  DELETE_CARE_PLAN_TEAM_SUCCESS,
  DELETE_CARE_PLAN_TEAM_FAILURE,
  SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL,
} from "./constants";

export const initialState = {
  carePlanTeam: [],
  carePlanTeamSearchList: [],
  currentCarePlanTeamMember: null,
  carePlanTeamTotal: 0,
  isFetchingCarePlanTeam: false,
  isSearchingCarePlanTeam: false,
  isSubmittingCarePlanTeam: false,
  isDeletingCarePlanTeam: false,
  carePlanTeamAddEditModal: { open: false, isEditing: false, member: null },
};

const CarePlanTeamReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SEARCH_CARE_PLAN_TEAM:
        draft.isSearchingCarePlanTeam = true;
        draft.carePlanTeamSearchList = [];
        break;
      case SEARCH_CARE_PLAN_TEAM_SUCCESS:
        draft.isSearchingCarePlanTeam = false;
        draft.carePlanTeamSearchList = Array.isArray(action.payload)
          ? action.payload
          : [];
        break;
      case SEARCH_CARE_PLAN_TEAM_FAILURE:
        draft.isSearchingCarePlanTeam = false;
        draft.carePlanTeamSearchList = [];
        break;

      case FETCH_CARE_PLAN_TEAM: {
        draft.isFetchingCarePlanTeam = true;
        const cptPage = action.payload?.page;
        if (cptPage === 1 || cptPage == null) {
          draft.carePlanTeam = [];
        }
        break;
      }
      case FETCH_CARE_PLAN_TEAM_SUCCESS: {
        draft.isFetchingCarePlanTeam = false;
        const payload = action.payload;
        const page = payload?.current_page ?? 1;
        if (page === 1) {
          draft.carePlanTeam = payload;
        } else {
          const prevData = Array.isArray(draft.carePlanTeam?.data)
            ? draft.carePlanTeam.data
            : [];
          const nextData = Array.isArray(payload?.data) ? payload.data : [];
          draft.carePlanTeam = {
            ...payload,
            data: [...prevData, ...nextData],
            current_page: page,
          };
        }
        draft.carePlanTeamTotal =
          payload?.total ?? draft.carePlanTeamTotal ?? 0;
        break;
      }
      case FETCH_CARE_PLAN_TEAM_FAILURE:
        draft.isFetchingCarePlanTeam = false;
        draft.carePlanTeam = [];
        break;

      case ADD_CARE_PLAN_TEAM:
        draft.isSubmittingCarePlanTeam = true;
        break;
      case ADD_CARE_PLAN_TEAM_SUCCESS:
        draft.isSubmittingCarePlanTeam = false;
        break;
      case ADD_CARE_PLAN_TEAM_FAILURE:
        draft.isSubmittingCarePlanTeam = false;
        break;

      case FETCH_CARE_PLAN_TEAM_MEMBER:
        draft.isFetchingCarePlanTeam = true;
        draft.currentCarePlanTeamMember = null;
        break;
      case FETCH_CARE_PLAN_TEAM_MEMBER_SUCCESS:
        draft.isFetchingCarePlanTeam = false;
        draft.currentCarePlanTeamMember = action.payload;
        break;
      case FETCH_CARE_PLAN_TEAM_MEMBER_FAILURE:
        draft.isFetchingCarePlanTeam = false;
        draft.currentCarePlanTeamMember = null;
        break;

      case EDIT_CARE_PLAN_TEAM:
        draft.isSubmittingCarePlanTeam = true;
        break;
      case EDIT_CARE_PLAN_TEAM_SUCCESS:
        draft.isSubmittingCarePlanTeam = false;
        break;
      case EDIT_CARE_PLAN_TEAM_FAILURE:
        draft.isSubmittingCarePlanTeam = false;
        break;

      case DELETE_CARE_PLAN_TEAM:
        draft.isDeletingCarePlanTeam = true;
        break;
      case DELETE_CARE_PLAN_TEAM_SUCCESS:
        draft.isDeletingCarePlanTeam = false;
        break;
      case DELETE_CARE_PLAN_TEAM_FAILURE:
        draft.isDeletingCarePlanTeam = false;
        break;

      case SET_CARE_PLAN_TEAM_ADD_EDIT_MODAL:
        draft.carePlanTeamAddEditModal = {
          open: action.payload?.open ?? false,
          isEditing: action.payload?.isEditing ?? false,
          member: action.payload?.member ?? null,
        };
        break;

      default:
        break;
    }
  });

export default CarePlanTeamReducer;
